import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('twofactor_authentication_setup'),
    subtitle: defineMessage('backup_codes'),
    checkboxText: defineMessage('yes_i_have_saved_the_backup_codes'),
    buttonDone: defineMessage('done'),
    errorCodesAreSaved: defineMessage('this_checkbox_is_required'),
};
